import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { decryptId } from '../../../Utils/Crypto';
import { useParams } from 'react-router-dom';
import { submitUpdatePostApi } from '../../../Services/SubmitUpdate/submitUpdate';

const SubmitUpdate = ({ comData }) => {
    const dispatch = useDispatch();
    const [isSubmitUpdateModalOpen, setIsSubmitUpdateModalOpen] = useState(false);
    const { loading: submitUpdateLoading } = useSelector(
        (state) => state.submitUpdatePostApi
    );
    const { encryptedId } = useParams();
    const id = decryptId(encryptedId);
    const [fileName, setFileName] = useState("");
    const [formData, setFormData] = useState({
        documentName: "",
        communityName: comData?.community_name,
        city: "",
        file: null,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            setFileName(file.name);
        } else {
            setFileName("");
        }
        setFormData((prevState) => ({
            ...prevState,
            file: file,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate if required fields are filled
        if (!formData.documentName) {
            toast.error("Please enter a document name.");
            return;
        }

        if (!formData.file) {
            toast.error("Please upload a file.");
            return;
        }

        // Create FormData object
        const formDataObj = new FormData();
        formDataObj.append("document_name", formData.documentName);
        formDataObj.append("community", id);
        formDataObj.append("city", comData?.location?.city);
        formDataObj.append("visitor_file", formData.file);

        try {
            const result = await dispatch(submitUpdatePostApi(formDataObj)).unwrap();
            setIsSubmitUpdateModalOpen(false);
            if (result?.status === 201) {
                toast.success("Data submitted successfully!");
            }
        } catch (error) {
            console.error("Error while submitting data:", error); // Log the error for debugging
            toast.error(error.response?.data?.message || "Something went wrong while submitting data!"); // Provide a detailed error message if available
        } finally {
            // Reset form state
            setFormData({
                documentName: "",
                city: "",
                file: null,
            });
            setFileName("");
        }
    };

    return (
        <div>
            <button
                className="btn-outline-orange"
                onClick={() => setIsSubmitUpdateModalOpen(true)}
            >
                Submit Update
            </button>

            {/* Backdrop */}
            {isSubmitUpdateModalOpen && (
                <div
                    className="modal-backdrop"
                    onClick={() =>
                        setIsSubmitUpdateModalOpen(false)
                    } // Close modal on backdrop click
                ></div>
            )}

            {/* Modal */}
            {isSubmitUpdateModalOpen && (
                <div
                    className="modal fade show"
                    tabIndex="-1"
                    style={{
                        display: "block",
                        paddingRight: "17px",
                    }}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="false"
                >
                    <div className="modal-dialog modal-dialog-centered submit-update">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1
                                    className="modal-title fs-5"
                                    id="exampleModalLabel"
                                >
                                    Submit Updated Document
                                </h1>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() =>
                                        setIsSubmitUpdateModalOpen(false)
                                    }
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p className="m-0 pb-3 please-upload">
                                    Please upload and share the most
                                    up-to-date and accurate information for
                                    this community. Documents are typically
                                    reviewed and verified within 24 hours
                                    before being updated in the system.
                                </p>
                                <span className="please-upload">
                                    Thank you for your contribution!
                                </span>
                                <form
                                    className="pt-4 d-flex flex-column gap-4"
                                    onSubmit={handleSubmit}
                                >
                                    <div className="form-group d-flex align-items-center">
                                        <label
                                            htmlFor="documentName"
                                            className="please-upload doc"
                                        >
                                            <b>Document Name:</b>
                                        </label>
                                        <input
                                            type="text"
                                            id="documentName"
                                            name="documentName"
                                            className="names-input"
                                            value={formData.documentName}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="form-group d-flex align-items-center">
                                        <label
                                            htmlFor="file"
                                            className="file-label file-uploader"
                                        >
                                            <b>File:</b>
                                        </label>
                                        <input
                                            type="file"
                                            id="file"
                                            name="file"
                                            className="file-input"
                                            onChange={handleFileChange}
                                        />
                                        <button
                                            type="button"
                                            className="upload-btn orange-filled-btn addcommunitybtn"
                                            onClick={() =>
                                                document
                                                    .getElementById("file")
                                                    .click()
                                            }
                                        >
                                            Upload File
                                        </button>
                                        {fileName && (
                                            <div className="mt-2 file-name">
                                                {fileName}
                                            </div>
                                        )}
                                    </div>
                                    <div className="text-center mt-4">
                                        <button
                                            className="btn-fill-orange"
                                            disabled={submitUpdateLoading}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}</div>
    )
}

export default SubmitUpdate